<script setup lang="ts">
import CallToAction from "@/components/landing/CallToAction.vue";
import FAQ from "@/components/landing/FAQ.vue";
import DownloadApp from "@/components/landing/DownloadApp.vue";
import Features from "@/components/landing/Features.vue";
import PopularRegions from "@/components/landing/PopularRegions.vue";
import Hero from "@/components/landing/Hero.vue";
</script>

<template>
  <Hero />
  <div class="max-w-5xl mx-auto">
    <PopularRegions />
    <Features />
    <DownloadApp />
    <div class="py-10" />
    <FAQ />
    <div class="py-10" />
    <CallToAction />
  </div>
</template>
